import React from 'react';
import './RightsInfo.scss'; // Import the CSS file for styling

const formatType = (type) => {
  if (!type || typeof type !== 'string') return '';

  // Convert camelCase or any other format to words with spaces and capitalize each word
  const formattedType = type
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

  return formattedType;
};

const RightsInfo = ({ rightsRestrictions }) => {
  if (!rightsRestrictions) {
    return null; // Return null if no data is provided
  }

  return (
    <div className="rights-info-wrap">
      <h6 className="rights-info-title">Rights and Restrictions</h6>
      <ul className="rights-listing">
        {rightsRestrictions.listed !== undefined && (
          <li>
            <p className="rights-title">Is the property listed?</p>
            <p className="rights-value">{rightsRestrictions.listed ? "Yes" : "No"}</p>
          </li>
        )}
        {rightsRestrictions.restrictions !== undefined && (
          <li>
            <p className="rights-title">Are there any restrictions associated with the property?</p>
            <p className="rights-value">{rightsRestrictions.restrictions ? "Yes" : "No"}</p>
          </li>
        )}
        {rightsRestrictions.easementsOrServitudesOrWayleaves !== undefined && (
          <li>
            <p className="rights-title">Are there any easements, servitudes, or wayleaves?</p>
            <p className="rights-value">{rightsRestrictions.easementsOrServitudesOrWayleaves ? "Yes" : "No"}</p>
          </li>
        )}
        {rightsRestrictions.rightOfWay !== undefined && (
          <li>
            <p className="rights-title">Are there any public rights of way across the property or its boundaries?</p>
            <p className="rights-value">{rightsRestrictions.rightOfWay ? "Yes" : "No"}</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default RightsInfo;